import { Injectable, EventEmitter } from '@angular/core';
import { RequestEventEmitter, ResponseEventEmitter } from './emitter';
import { GlobalsServiceConfig } from './globals.config';
import { GridOptions } from "ag-grid-community";
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class GlobalsService {
    public IsBusy: BehaviorSubject<boolean>;
    public JsEnumerations: any = "";
    public LoadingMessage: string = "";

    beforeRequest: RequestEventEmitter;
    afterRequest: ResponseEventEmitter;
    subventionLoad: EventEmitter<boolean>;

    constructor(private config: GlobalsServiceConfig) {
        this.IsBusy = new BehaviorSubject<boolean>(false);
        this.config.CatchHttpErrorsGlobal = this.config.CatchHttpErrorsGlobal || false;
        this.config.GridOptions = this.config.GridOptions || {};
        this.config.GridOptions.localeText = {
            // for filter panel
            page: 'Seite',
            to: 'bis',
            of: 'von',
            next: 'Nächste',
            last: 'Letzte',
            first: 'Erste',
            previous: 'Voherige',
            loadingOoo: 'Wird geladen...',
            noRowsToShow: "Keine Zeile zum Anzeigen",
        };


        this.beforeRequest = new RequestEventEmitter();
        this.afterRequest = new ResponseEventEmitter();
        this.subventionLoad = new EventEmitter<boolean>()
    }

    public CatchHttpErrorsGlobal: boolean = this.config.CatchHttpErrorsGlobal;
    public GridOptions: GridOptions = this.config.GridOptions;
    public InfiniteScroolGridOptions: GridOptions = this.config.InfiniteScroolGridOptions || {};


    //private currentWohnhausIdSource : Subject<string> = new Subject<string>();
    //private currentWohnhausId : string;
    //public currentWohnhausChanged : Observable<string> = this.currentWohnhausIdSource.asObservable();

    // public getCurrentWohnhausId() : string {
    //     if (this.currentWohnhausId != null && this.currentWohnhausId != "") {
    //         return this.currentWohnhausId;
    //     }
    //     return "";
    // }

    // public setCurrentWohnhausId(wohnhausId : string) {
    //     if (wohnhausId != "") {
    //         this.currentWohnhausId = wohnhausId;
    //         this.currentWohnhausIdSource.next(wohnhausId);
    //     }
    // }
}


// WEBPACK FOOTER //
// ./src/app/shared/globals.service.ts